// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd33dec9","453":"e030989d","591":"3eac0ff7","869":"f446c310","962":"3a65cc4e"}[chunkId] + ".chunk.js";
};